/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RootStoreType } from "./index"


/**
 * RouteLastLocationDtoBase
 * auto generated base class for the model RouteLastLocationDtoModel.
 */
export const RouteLastLocationDtoModelBase = ModelBase
  .named('RouteLastLocationDto')
  .props({
    __typename: types.optional(types.literal("RouteLastLocationDto"), "RouteLastLocationDto"),
    routeId: types.union(types.undefined, types.string),
    visitId: types.union(types.undefined, types.null, types.integer),
    eventUuid: types.union(types.undefined, types.null, types.string),
    latitude: types.union(types.undefined, types.number),
    longitude: types.union(types.undefined, types.number),
    timestamp: types.union(types.undefined, types.string),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class RouteLastLocationDtoModelSelector extends QueryBuilder {
  get routeId() { return this.__attr(`routeId`) }
  get visitId() { return this.__attr(`visitId`) }
  get eventUuid() { return this.__attr(`eventUuid`) }
  get latitude() { return this.__attr(`latitude`) }
  get longitude() { return this.__attr(`longitude`) }
  get timestamp() { return this.__attr(`timestamp`) }
}
export function selectFromRouteLastLocationDto() {
  return new RouteLastLocationDtoModelSelector()
}

export const routeLastLocationDtoModelPrimitives = selectFromRouteLastLocationDto().routeId.visitId.eventUuid.latitude.longitude.timestamp
